<template>
	<div class="">
		<el-form ref="addForm"
				 :rules="formRules"
				 :model="addForm"
				 label-width="150px">
			<el-row>
				<el-col :span="11">
					<el-form-item label="工程名称"
								  prop="projectName">
						<el-input placeholder="请输入"
								  :disabled="isDisabled"
								  v-model="addForm.projectName"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="开工日期"
								  prop="startDate">
						<el-date-picker v-model="addForm.startDate"
										type="date"
										:disabled="isDisabled"
										format="yyyy 年 MM 月 dd 日"
										value-format="yyyy-MM-dd"
										placeholder="请选择日期">
						</el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11">
					<el-form-item label="竣工日期"
								  prop="completeDate">
						<el-date-picker v-model="addForm.completeDate"
										type="date"
										:disabled="isDisabled"
										format="yyyy 年 MM 月 dd 日"
										value-format="yyyy-MM-dd"
										placeholder="请选择日期">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="地区"
								  prop="curArea">
						<el-cascader v-model="addForm.curArea"
									 :options="areaList"
									 :disabled="isDisabled"
									 @change="handleChange"
									 placeholder="请选择"></el-cascader>
					</el-form-item>
				</el-col>
			</el-row>
			<!-- <el-row>
				<el-col :span="11">
					<el-form-item label="申报金额类型"
								  prop="declaredType">
						<el-select v-model="addForm.declaredType"
								   :disabled="isDisabled"
								   placeholder="请选择">
							<el-option v-for="(item, index) in declaredTypeList"
									   :key="'申报类型' + index"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row> -->
			<el-row>
				<el-col :span="11">
					<el-form-item label="工程类型"
								  prop="projectType">
						<el-select v-model="addForm.projectType"
								   :disabled="isDisabled"
								   placeholder="请选择">
							<el-option v-for="(item, index) in typeList"
									   :key="'类型' + index"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="建设单位"
								  prop="companyBuild">
						<el-input placeholder="请输入"
								  :disabled="isDisabled"
								  v-model="addForm.companyBuild"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11">
					<el-form-item label="施工单位"
								  prop="companyConstruction">
						<el-input placeholder="请输入"
								  :disabled="isDisabled"
								  v-model="addForm.companyConstruction"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="审计单位"
								  prop="companyAudit">
						<el-input placeholder="请输入"
								  :disabled="isDisabled"
								  v-model="addForm.companyAudit"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11">
					<el-form-item label="招标方式"
								  prop="tenderType">
						<el-select v-model="addForm.tenderType"
								   :disabled="isDisabled"
								   placeholder="请选择">
							<el-option v-for="(item, index) in biddingList"
									   :key="'招标方式' + index"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="合同价"
								  prop="moneyContractPrice">
						<el-input placeholder="请输入"
								  :disabled="isDisabled"
								  type="number"
								  v-model="addForm.moneyContractPrice">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11">
					<el-form-item label="审定价"
								  prop="moneyAuthorizedPrice">
						<el-input placeholder="请输入"
								  :disabled="isDisabled"
								  type="number"
								  v-model="addForm.moneyAuthorizedPrice">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="备注"
								  prop="tag">
						<el-input placeholder="请输入"
								  type="textarea"
								  :disabled="isDisabled"
								  :autosize="{ minRows: 2, maxRows: 5}"
								  v-model="addForm.tag"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<!-- <el-row>
				<el-col :span="11">
					<el-form-item label="文件上传">
						<my-upload :aid="aid"
								   :mode="rowType"
								   ref="myUpload"
								   :acceptType="acceptType"
								   @on-upload="onUpload"></my-upload>
					</el-form-item>
				</el-col>
			</el-row> -->
		</el-form>
	</div>

</template>


<script>
const myUpload = () => import('./upload')
import { addData } from '@/api/modules/project_manage'
import { getAllAreaTree } from '@/api/modules/dict'
import { mapState } from 'vuex'
export default {
	name: 'addnew',
	components: { myUpload },
	props: {
		rowInfo: {
			type: Object,
			default: () => {
				return {}
			}
		},
		rowType: {
			type: String,
			default: 'add'
		}
	},
	data() {
		return {
			addway: '1',
			addmethod: '1',
			declaredTypeList: [
				{ sname:'当期金额', value: 0 },
				{ sname:'累计金额', value: 1 }
			],

			areaList: [],
			addForm: {
				curArea: [], // 地区数组
				projectName: '', // 工程名称
				startDate: '', // 开工年份
				completeDate: '', // 竣工年份
				area: [], // 地区单个值
				projectType: '', // 工程类型
				companyBuild: '', // 建设单位
				companyConstruction: '', // 施工单位
				companyAudit: '', // 审计单位
				tenderType: '', // 招标方式
				moneyContractPrice: '', // 合同价
				moneyAuthorizedPrice: '', // 审定价
				tag: '', // 备注
				projectResource: '1013001', // 工程来源(暂时写死)
				declaredType: ''
			},
			formRules: {
				// 表单验证
				projectName: [
					{
						required: true,
						message: '请输入工程名称',
						trigger: 'blur'
					},
					{
						min: 0,
						max: 80,
						message: '最多80个字符',
						trigger: 'blur'
					}
				],
				// declaredType: [
				// 	{
				// 		required: true,
				// 		message: '请选择申报金额类型',
				// 		trigger: 'blur'
				// 	}
				// ],
				startDate: [
					{
						type: 'string',
						required: true,
						message: '请选择开工日期',
						trigger: 'change'
					}
				],
				completeDate: [
					{
						type: 'string',
						required: true,
						message: '请选择竣工日期',
						trigger: 'change'
					}
				],
				curArea: [
					{ required: true, message: '请选择地区', trigger: 'change' }
				],
				projectType: [
					{
						required: true,
						message: '请选择工程类型',
						trigger: 'change'
					}
				]
				// companyBuild: [
				// 	{
				// 		required: true,
				// 		message: '请输入建设单位',
				// 		trigger: 'blur'
				// 	},
				// 	{
				// 		min: 0,
				// 		max: 80,
				// 		message: '最多80个字符',
				// 		trigger: 'blur'
				// 	}
				// ],
				// companyConstruction: [
				// 	{
				// 		required: true,
				// 		message: '请输入施工单位',
				// 		trigger: 'blur'
				// 	},
				// 	{
				// 		min: 0,
				// 		max: 80,
				// 		message: '最多80个字符',
				// 		trigger: 'blur'
				// 	}
				// ],
				// companyAudit: [
				// 	{
				// 		required: true,
				// 		message: '请输入审计单位',
				// 		trigger: 'blur'
				// 	},
				// 	{
				// 		min: 0,
				// 		max: 80,
				// 		message: '最多80个字符',
				// 		trigger: 'blur'
				// 	}
				// ],
				// tenderType: [
				// 	{
				// 		required: true,
				// 		message: '请选择招标方式',
				// 		trigger: 'change'
				// 	}
				// ]
			},
			isDisabled: false,
			aid: '', // 上传组件业务表ID
			acceptType: []
		}
	},
	methods: {
		handleChange(val) {
			this.addForm.area = val[val.length - 1]
		},
		// 上传事件回调
		onUpload(status) {
			if (status) {
				this.$emit('onSuccess')
			} else {
				this.$emit('onCancel')
			}
		},
		doConfirm() {
			let params = Object.assign({}, this.addForm)
			this.$refs.addForm.validate(valid => {
				if (valid) {
					addData(params).then(res => {
						// this.$emit('onSuccess')
						// 上传文件
						// this.$refs.myUpload.fileUpload(res.data.id)
						if (res.operationCode == 1) {
							this.$message.success('新建成功')
							this.$router.push({
								path: `/project-list`
							})
						} else{
							this.$message.warning('已存在此项目名称')
						}
					})
				} 
				// else {
				// 	setTimeout(() => {
				// 		this.$emit('onCancel')
				// 	}, 3000)
				// 	return false
				// }
			})
		}
	},
	computed: {
		...mapState('dict', {
			typeList: state => state.gclx, //项目类型数组
			biddingList: state => state.zbfs //招标方式
		})
	},
	created() {
		getAllAreaTree({})
			.then(res => {
				this.areaList = res.data
			})
			.catch(err => {})
	}
}
</script>

<style scoped lang="less">
</style>
